<div class="flyout-utm-campaigns-component">
  <div class="flyout-data-group">
    <mat-expansion-panel [expanded]="true" class="mat-elevation-z0">
      <mat-expansion-panel-header [collapsedHeight]="'48px'" [expandedHeight]="'48px'">
        <span>{{ "flyout.campaign-info.utm-campaigns" | translate }}</span>
      </mat-expansion-panel-header>

      <div class="expansion-panel-row header">
        <div class="label name" (click)="sortByProperty('campaignName')">
          <span>{{ "flyout.campaign-info.name" | translate }}</span>
          @if (sortingProperty === "campaignName") {
            <span>
              @if (sortingDirection === 1) {
                <mat-icon>arrow_drop_up</mat-icon>
              }
              @if (sortingDirection === -1) {
                <mat-icon>arrow_drop_down</mat-icon>
              }
            </span>
          }
        </div>
        <div class="label value-label" (click)="sortByProperty('count')">
          <span>{{ "flyout.campaign-info.count" | translate }}</span>
          @if (sortingProperty === "count") {
            <span>
              @if (sortingDirection === 1) {
                <mat-icon>arrow_drop_up</mat-icon>
              }
              @if (sortingDirection === -1) {
                <mat-icon>arrow_drop_down</mat-icon>
              }
            </span>
          }
        </div>
      </div>

      @for (stat of campaignsStatistics; track stat) {
        <div class="expansion-panel-row values">
          <div class="value name">{{ stat.campaignName | titlecase }}</div>
          <div class="value number">{{ stat.count }}</div>
        </div>
      }
    </mat-expansion-panel>
  </div>
</div>
